<template>
  <v-autocomplete
      :error-messages="error"
      variant="outlined"
      rounded="lg"
      bg-color="surface"
      :label="translation(translationList.vehicle_usage_type, 'Tip utilizare')"
      :items="vehicleUsageTypes"
      item-title="name"
      name="usage_type"
      item-value="id"
      v-model="selectedVehicleUsageType"
      :rules="[v => !!v || translation(translationList.required, 'Acest camp este obligatoriu')]"
      return-object
  >
  </v-autocomplete>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, toRefs, watch } from 'vue';
import { useVehicleStore } from '~/plugins/store/vehicle';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type {VehicleUsageType} from "~/types/Vehicle";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    modelValue: {
      type: Object as () => VehicleUsageType | null,
      default: () => null,
      required: false
    },
  },
  emits: ['update:modelValue', 'validation-vehicle-status'],
  setup(props, { emit }) {
    const { modelValue } = toRefs(props);
    const vehicleStore = useVehicleStore();
    const translationStore = useTranslationStore();
    const selectedVehicleUsageType = ref(modelValue.value ? modelValue.value : null);
    const vehicleUsageTypes = ref<VehicleUsageType[]>([]);
    const translationList = ref<TranslationList>({});
    let initialSetupDone = false;
    const error = ref([]);

    onMounted(async () => {
      const usageTypes = await vehicleStore.getVehicleUsageTypes();
      if (usageTypes && usageTypes.length > 0) {
        vehicleUsageTypes.value = usageTypes;
      }
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');
      initialSetupDone = true;

      if (!modelValue.value && vehicleUsageTypes.value.length > 0) {
        selectedVehicleUsageType.value = vehicleUsageTypes.value[0];
        emit('update:modelValue', selectedVehicleUsageType.value);
      }
      const isValid = !!selectedVehicleUsageType.value;
      emit('validation-vehicle-status', { field: 'usage_type', isValid });

      // Listen for validate event
      window.addEventListener('validate-vehicle', (data) => {
        if (data.detail && data.detail === 'usage_type' && !selectedVehicleUsageType.value) {
          error.value.push(translation(translationList.value.required, 'Acest câmp este obligatoriu'));
        } else {
          error.value = [];
          emit('validation-vehicle-status', { field: 'usage_type', isValid: true });
        }
      });
    });

    watch(selectedVehicleUsageType, (newUsageType) => {
      if (initialSetupDone) {
        emit('update:modelValue', newUsageType);
      }
    });

    watch(modelValue, (newValue) => {
      if (newValue) {
        selectedVehicleUsageType.value = newValue;
        error.value = [];
      }
      const isValid = !!newValue;
      emit('validation-vehicle-status', { field: 'usage_type', isValid });
    });


    return {
      selectedVehicleUsageType,
      translationList,
      translation,
      vehicleUsageTypes,
      error,
    };
  },
});
</script>

<style scoped>
</style>
